import React from 'react';
import {
  Box, Paper, Typography, Button, TextField, Divider, useTheme, alpha,
} from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';

const SupplierWineLinkForm: React.FC = () => {
  const navigate = useNavigate();
  const { supplierId } = useParams<{ supplierId: string }>();
  const theme = useTheme();
  const backPath = `/admin/suppliers/${supplierId}`;

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <Box sx={{ px: 3, py: 2.5, display: 'flex', alignItems: 'center', gap: 2, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.12)}` }}>
          <Button startIcon={<BackIcon />} onClick={() => navigate(backPath)} sx={{ textTransform: 'none', color: theme.palette.text.secondary }}>
            Supplier
          </Button>
          <Divider orientation="vertical" flexItem />
          <Typography variant="h6" fontWeight={600}>Link Wine to Supplier</Typography>
        </Box>
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField label="Wine" fullWidth disabled placeholder="Search wine — WineSearchBox (Phase 9)" />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField label="Supplier SKU / Reference" fullWidth disabled placeholder="Supplier's product code" />
            <TextField label="List Price" fullWidth disabled type="number" />
            <TextField label="Currency" disabled placeholder="EUR" sx={{ minWidth: 100 }} />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField label="Min Order Qty" fullWidth disabled type="number" />
            <TextField label="Lead Time (days)" fullWidth disabled type="number" />
          </Box>
          <Box sx={{ pt: 1.5, borderTop: `1px solid ${alpha(theme.palette.divider, 0.12)}`, display: 'flex', gap: 1.5, justifyContent: 'flex-end' }}>
            <Button onClick={() => navigate(backPath)} sx={{ textTransform: 'none' }}>Cancel</Button>
            <Button variant="contained" disabled sx={{ textTransform: 'none', fontWeight: 600 }}>Link Wine</Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'right' }}>Enabled in Phase 9</Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SupplierWineLinkForm;
